<script>
export default {
  name: 'ReturnNavigation'
}
</script>

<script setup>
import { url } from '@/config/urls';
import router from '@/router/index.js';

// コンポーネントに渡されたpropsの取得
const props = defineProps({
  /**
   * 画面ID
   *    [返品依頼TOP] ReturnSearch
   *    [返品履歴] ReturnHistory
   *    [返品ボックス] ReturnBox
   */
  screenId: {
    type: String,
    required: true
  },
  // カート商品 品目数
  returnBoxTotalRecord: {
    type: Number,
    required: true
  },
  returnSearchPageUrl: {
    type: String,
    default: url.page.returnSearch
  },
  returnHistoryPageUrl: {
    type: String,
    default: url.page.returnHistory
  },
  returnBoxPageUrl: {
    type: String,
    default: url.page.returnBox
  }
});

</script>

<template>
  <div class="com_inner2 clearfix">
    <ul class="com_links1">
      <li><router-link :to="props.returnSearchPageUrl" :class="{ current: props.screenId === 'ReturnSearch' }">返品依頼TOP</router-link></li>
      <li><router-link :to="props.returnHistoryPageUrl" :class="{ current: props.screenId === 'ReturnHistory' }">返品履歴</router-link></li>
      <li><router-link :to="props.returnBoxPageUrl" :class="{ current: props.screenId === 'ReturnBox' }">返品ボックス
        <img :src="props.screenId === 'ReturnBox' ? '/front/assets/common/img/icon_return_box2.png' : '/front/assets/common/img/icon_return_box1.png'" alt="" class="icon_return_box1">
        <span v-if="props.returnBoxTotalRecord != null && props.returnBoxTotalRecord > 0" class="com_cart_num1">{{ props.returnBoxTotalRecord }}</span>
      </router-link></li>
    </ul>
  </div>
</template>
